export class StatsAnswer {
  QuestionNum: number;
  Answer: string;

  constructor(questionNum: number, answer: string) {
    this.QuestionNum = questionNum;
    this.Answer = answer;
  }
}
